import { render, staticRenderFns } from "./distributorAllocation.vue?vue&type=template&id=68ce6bd1&scoped=true&"
import script from "./distributorAllocation.vue?vue&type=script&lang=js&"
export * from "./distributorAllocation.vue?vue&type=script&lang=js&"
import style0 from "./distributorAllocation.vue?vue&type=style&index=0&id=68ce6bd1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ce6bd1",
  null
  
)

export default component.exports